import PropTypes from 'prop-types';

import ParticipantIcon from '../../../../ParticipantIcon';

const ChatAuthorIcon = function ChatAuthorIcon({
  author,
  initials,
  color,
  gcatCode,
  grpGpid,
  grpLbl,
  groupsMap,
  imagesMap,
  fullWidth,
}) {
  if (!author) return null;

  if (fullWidth) return null;

  // if (color === '#a53700') {
  //   console.log(`ChatAuthorIcon color=${color}`);
  // }

  return (
    <ParticipantIcon
      initials={initials}
      color={color}
      gcatCode={gcatCode}
      grpGpid={grpGpid}
      grpLbl={grpLbl}
      groupsMap={groupsMap}
      imagesMap={imagesMap}
      className="self-start"
    />
  );
};

ChatAuthorIcon.propTypes = {
  author: PropTypes.string,
  initials: PropTypes.string,
  color: PropTypes.string,
  gcatCode: PropTypes.string,
  grpGpid: PropTypes.string,
  grpLbl: PropTypes.string,
  groupsMap: PropTypes.instanceOf(Map).isRequired,
  imagesMap: PropTypes.instanceOf(Map).isRequired,
  fullWidth: PropTypes.bool,
};

export default ChatAuthorIcon;
